import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';

import { formatPrice } from '../../lib/money';
import ProductImage from '../storefront/ProductImage';
import { FONT_BODY } from '../storefront/storefrontStyles';
import { safeExternalUrl } from '../../brand';

// Lo que la tienda está mostrando ahora, destacado sobre el video: un producto
// del catálogo pineado (abre el diálogo de compra) o un link cargado a mano
// (se abre en otra pestaña, como siempre). Nada pineado → no se muestra.
const PinnedSpotlight = ({ pinnedProduct, pinnedUrl: rawPinnedUrl, onOpenProduct, sx }) => {
    // lo carga la tienda: se descarta cualquier cosa que no sea http/https (p. ej. "javascript:")
    const pinnedUrl = safeExternalUrl(rawPinnedUrl);
    if (pinnedProduct) {
        return (
            <Box
                component="button"
                type="button"
                onClick={() => onOpenProduct(pinnedProduct)}
                aria-label={`Ver ${pinnedProduct.name}`}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.25,
                    width: '100%',
                    p: 1,
                    textAlign: 'left',
                    cursor: 'pointer',
                    color: 'white',
                    backgroundColor: 'rgba(15,15,22,0.88)',
                    border: '1.5px solid #29D2AB',
                    borderRadius: '14px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.45)',
                    ...sx,
                }}
            >
                <Box
                    sx={{
                        width: 64,
                        flexShrink: 0,
                        borderRadius: '10px',
                        overflow: 'hidden',
                    }}
                >
                    <ProductImage
                        src={pinnedProduct.imageUrl}
                        alt={pinnedProduct.name}
                    />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        sx={{
                            color: '#29D2AB',
                            fontSize: 10,
                            fontWeight: 800,
                            fontFamily: FONT_BODY,
                            textTransform: 'uppercase',
                            letterSpacing: 0.5,
                        }}
                    >
                        En pantalla
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            fontFamily: FONT_BODY,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {pinnedProduct.name}
                    </Typography>
                    <Box
                        sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}
                    >
                        <Typography
                            sx={{
                                fontSize: 15,
                                fontWeight: 800,
                                fontFamily: FONT_BODY,
                            }}
                        >
                            {formatPrice(pinnedProduct.price)}
                        </Typography>
                        {pinnedProduct.compareAtPrice != null &&
                            pinnedProduct.compareAtPrice >
                                pinnedProduct.price && (
                                <Typography
                                    sx={{
                                        fontSize: 12,
                                        color: '#aaa',
                                        textDecoration: 'line-through',
                                        fontFamily: FONT_BODY,
                                    }}
                                >
                                    {formatPrice(pinnedProduct.compareAtPrice)}
                                </Typography>
                            )}
                    </Box>
                </Box>
                <Box
                    sx={{
                        flexShrink: 0,
                        backgroundColor: '#29D2AB',
                        color: '#0F1B2D',
                        fontWeight: 800,
                        fontSize: 12,
                        fontFamily: FONT_BODY,
                        borderRadius: '8px',
                        px: 1.5,
                        py: 1,
                    }}
                >
                    Comprar
                </Box>
            </Box>
        );
    }

    if (pinnedUrl) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', ...sx }}>
                <Button
                    variant="contained"
                    href={pinnedUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    endIcon={<OpenInNewIcon />}
                    sx={{
                        bgcolor: 'rgba(29,152,231,0.9)',
                        color: '#fff',
                        py: 1.5,
                        px: 2,
                        '&:hover': { bgcolor: 'rgba(29,152,231,1)' },
                    }}
                >
                    Ver producto
                </Button>
            </Box>
        );
    }

    return null;
};

export default PinnedSpotlight;
